// PayIntern.js
import React, { useState } from "react";
import axios from "axios";
import "../styles/PayIntern.css";

const PayIntern = () => {
  const [formData, setFormData] = useState({
    internId: "",
    internName: "",
    email: "",
    mobile: "",
    amount: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.internId || !formData.internName || !formData.amount) {
      alert("Please fill all required fields");
      return;
    }

    setIsLoading(true);

    try {
      const orderId = "INT-" + Math.floor(Math.random() * 1000000);

      const response = await axios.post("/api/payment/create-session", {
        name: formData.internName,
        email: formData.email,
        mobile: formData.mobile,
        orderId,
        type: "internship",
        amount: formData.amount,
      });

      const { payment_links } = response.data;

      if (payment_links?.web) {
        window.location.href = payment_links.web;
      } else {
        alert("Payment failed: No payment link returned");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="payintern-wrapper">
      <div className="payintern-card">
        <h2 className="payintern-title">💰 Pay for Internship</h2>

        <div className="payintern-terms">
          <h4>📌 Terms & Conditions</h4>
          <ul>
            <li>
              Payment is non-refundable once completed.
            </li>
            <li>
              Please enter correct details before proceeding.
            </li>
            <li>
              Payment confirms your internship registration.
            </li>
            <li>
              Contact support within <strong>24 hours</strong> for issues.
            </li>
          </ul>
        </div>

        <form className="payintern-form" onSubmit={handleSubmit}>
          <input
            name="internId"
            placeholder="Intern ID"
            value={formData.internId}
            onChange={handleChange}
            required
          />
          <input
            name="internName"
            placeholder="Intern Name"
            value={formData.internName}
            onChange={handleChange}
            required
          />
          <input
            name="email"
            type="email"
            placeholder="Email (optional)"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            name="mobile"
            type="tel"
            placeholder="Mobile Number (optional)"
            value={formData.mobile}
            onChange={handleChange}
          />
          <input
            name="amount"
            type="number"
            placeholder="Amount (₹)"
            value={formData.amount}
            onChange={handleChange}
            required
          />

          <button type="submit" disabled={isLoading}>
            {isLoading ? "Processing..." : "Proceed to Pay"}
          </button>

          {message && <p className="error-message">{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default PayIntern;
